import {
  GET_SCHEMA_SPECS_SUCCESS,
  GET_PUBLIC_SCHEMA_SPECS_SUCCESS,
  GET_SCHEMA_SPEC_LISTING_SUCCESS,
  CREATE_SCHEMA_SPEC_SUCCESS,
  UPDATE_SCHEMA_SPEC_SUCCESS,
  DELETE_SCHEMA_SPEC_SUCCESS,
  GET_SCHEMA_SPEC_DOC_SUCCESS,
  UPDATE_SCHEMA_SPEC_DOC_SUCCESS,
  LOGOUT_COMPLETE,
  GET_SCHEMA_SPEC_SUCCESS,
} from '../../constants/actionTypes';

import DataSchemaProcessor from '../../lib/DataSchemaProcessor';
import DataSamplesProcessor from '../../lib/DataSamplesProcessor';

import pick from 'lodash/pick';
import forOwn from 'lodash/forOwn';
import forEach from 'lodash/forEach';
import mapKeys from 'lodash/mapKeys';
import orderBy from 'lodash/orderBy';
import map from 'lodash/map';
import union from 'lodash/union';
import pullAll from 'lodash/pullAll';
import cloneDeep from 'lodash/cloneDeep';
import filter from 'lodash/filter';
import has from 'lodash/has';
import isEmpty from 'lodash/isEmpty';

const initialState = {
  lastUpdated: null,
  lastUpdatedPublic: null,
  listing: [],
  sortedIds: [],
  sortedPublicIds: [],
  flatSchemas: {},
  nestedSchemas: {},
  flatSamples: {},
  nestedSamples: {},
  docById: {},
};

export const schemaSpecsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SCHEMA_SPECS_SUCCESS:
    case GET_SCHEMA_SPEC_SUCCESS:
      return saveAllSchemaSpecs(state, action);

    case GET_PUBLIC_SCHEMA_SPECS_SUCCESS:
      return savePublicSchemaSpecs(state, action);

    case GET_SCHEMA_SPEC_LISTING_SUCCESS:
      return saveSchemaSpecListing(state, action);

    case CREATE_SCHEMA_SPEC_SUCCESS:
      return saveAllSchemaSpecs(state, action);

    case UPDATE_SCHEMA_SPEC_SUCCESS:
      return updateSchemaSpec(state, action);

    case DELETE_SCHEMA_SPEC_SUCCESS:
      return deleteSchemaSpecs(state, action);

    case GET_SCHEMA_SPEC_DOC_SUCCESS:
    case UPDATE_SCHEMA_SPEC_DOC_SUCCESS:
      return saveSchemaSpecDoc(state, action);

    case LOGOUT_COMPLETE:
      return initialState;

    default:
      return state;
  }
};

export default schemaSpecsReducer;

function saveAllSchemaSpecs(state, action) {
  const {
    entities: { schemaSpecs },
    // result,
    receivedAt,
  } = action;
  const { flatSchemas, nestedSchemas, flatSamples, nestedSamples } = processSchemaSpecs(
    state,
    schemaSpecs,
  );
  const sortedEntities = orderBy(schemaSpecs, ['created_at'], ['desc']);
  const sortedIds = map(sortedEntities, 'id');
  // NOTE: No API hack.
  const allSortedIds = union(sortedIds, state.sortedIds);

  return {
    ...state,
    lastUpdated: receivedAt,
    flatSchemas: { ...state.flatSchemas, ...flatSchemas },
    nestedSchemas: { ...state.nestedSchemas, ...nestedSchemas },
    flatSamples: { ...state.flatSamples, ...flatSamples },
    nestedSamples: { ...state.nestedSamples, ...nestedSamples },
    sortedIds: pullAll(allSortedIds, state.sortedPublicIds),
  };
}

function savePublicSchemaSpecs(state, action) {
  const {
    entities: { schemaSpecs },
    receivedAt,
  } = action;
  const { flatSchemas, nestedSchemas, flatSamples, nestedSamples } = processSchemaSpecs(
    state,
    schemaSpecs,
  );
  const sortedEntities = orderBy(schemaSpecs, ['created_at'], ['desc']);
  const sortedPublicIds = map(sortedEntities, 'id');
  const allSortedPublicIds = union(sortedPublicIds, state.sortedPublicIds);

  return {
    ...state,
    lastUpdatedPublic: receivedAt,
    flatSchemas: { ...state.flatSchemas, ...flatSchemas },
    nestedSchemas: { ...state.nestedSchemas, ...nestedSchemas },
    nestedSamples: { ...state.nestedSamples, ...nestedSamples },
    flatSamples: { ...state.flatSamples, ...flatSamples },
    sortedIds: pullAll(state.sortedIds, allSortedPublicIds),
    sortedPublicIds: allSortedPublicIds,
  };
}

function saveSchemaSpecListing(state, action) {
  const {
    entities: { schemaSpecs },
    result,
    receivedAt,
  } = action;
  const { flatSchemas, nestedSchemas, flatSamples, nestedSamples } = processSchemaSpecs(
    state,
    schemaSpecs,
  );

  return {
    ...state,
    listing: result,
    lastUpdated: receivedAt,
    flatSchemas: { ...state.flatSchemas, ...flatSchemas },
    nestedSchemas: { ...state.nestedSchemas, ...nestedSchemas },
    flatSamples: { ...state.flatSamples, ...flatSamples },
    nestedSamples: { ...state.nestedSamples, ...nestedSamples },
  };
}

function updateSchemaSpec(state, action) {
  const {
    entities: { schemaSpecs },
    receivedAt,
    requestInfo: { id },
  } = action;

  const { flatSchemas, nestedSchemas, flatSamples, nestedSamples } = processSchemaSpecs(
    state,
    schemaSpecs,
    id,
  );
  return {
    ...state,
    lastUpdated: receivedAt,
    flatSchemas: {
      ...state.flatSchemas,
      [id]: flatSchemas[id],
    },
    nestedSchemas: {
      ...state.nestedSchemas,
      [id]: nestedSchemas[id],
    },
    flatSamples: {
      ...state.flatSamples,
      [id]: flatSamples[id],
    },
    nestedSamples: {
      ...state.nestedSamples,
      [id]: nestedSamples[id],
    },
  };
}

function processSchemaSpecs(currentState, schemaSpecs, schemaSpecIds = null) {
  let schemaSpecsToProcess = schemaSpecIds ? pick(schemaSpecs, schemaSpecIds) : schemaSpecs;

  // //Flattening schema is an expensive process. Let's make sure we only flatten schemas for schemas that have been updated since last flatten. Ideally we should even check if there was a check in Nexset schema and not just any update.
  //
  // let schemasToUpdate = pickBy(dataSetsToProcess, function(s) {
  //   return (
  //     !has(currentState, [s.id]) ||
  //     currentState[s.id].lastUpdated !== s.updated_at
  //   );
  // });

  //1. Flatten all schemas
  let schemaSpecSchemas = {};
  let schemaSpecSamples = {};
  let schemaSpecNestedSchemas = {};
  let nestedSamples = {};

  forOwn(schemaSpecsToProcess, function (sp, id) {
    const schema = cloneDeep(sp.schema);
    const samples = cloneDeep(sp.data_samples);
    schemaSpecSchemas[id] = getFlatSchemaFromNested(schema);
    schemaSpecSamples[id] = getFlatSamplesFromNested(samples);
    schemaSpecNestedSchemas[id] = mapKeys(schemaSpecSchemas[id], '__name');
    nestedSamples[id] = samples;
  });

  return {
    nestedSchemas: schemaSpecNestedSchemas,
    flatSchemas: schemaSpecSchemas,
    flatSamples: schemaSpecSamples,
    nestedSamples: nestedSamples,
  };
}

function getFlatSchemaFromNested(schema) {
  //if schema has nexla meta data, discard it
  let schemaToFlatten = schema.properties;

  let flatSchema = DataSchemaProcessor.flattenSchema(
    schemaToFlatten,
    schema.required,
    0,
    null,
    null,
    null,
    true,
  );

  return flatSchema;
}

function getFlatSamplesFromNested(samplesToFlatten = []) {
  let flatSamples = [];
  forEach(samplesToFlatten, (s) => {
    flatSamples.push(DataSamplesProcessor.flattenSamples(s));
  });

  return flatSamples;
}

function deleteSchemaSpecs(state, action) {
  const {
    requestInfo: { id },
    receivedAt,
  } = action;
  const filterFunction = (sId) => sId !== id;
  const newListing = filter(state.listing, filterFunction);
  const newIds = filter(state.sortedIds, filterFunction);

  const newFlatSchemas = { ...state.flatSchemas };
  delete newFlatSchemas[id];

  const newNestedSchemas = { ...state.nestedSchemas };
  delete newNestedSchemas[id];

  const newFlatSamples = { ...state.flatSamples };
  delete newFlatSamples[id];

  const newDocById = { ...state.docById };
  delete newDocById[id];

  const newNestedSamples = { ...state.nestedSamples };
  delete newNestedSamples[id];

  return {
    ...state,
    lastUpdated: receivedAt,
    listing: newListing,
    sortedIds: newIds,
    flatSchemas: newFlatSchemas,
    nestedSchemas: newNestedSchemas,
    flatSamples: newFlatSamples,
    docById: newDocById,
    nestedSamples: newNestedSamples,
  };
}

function saveSchemaSpecDoc(state, action) {
  const {
    result,
    requestInfo: { id },
  } = action;

  return {
    ...state,
    docById: {
      [id]: isEmpty(result) ? null : result[0],
    },
  };
}
